import { createAsyncThunk } from '@reduxjs/toolkit';
import { searchApi } from '../../../api/searchApi';
import { setApiReachable, setApiUnreachable } from '../../networkStatus/networkStatusSlice';
import offlineOrTimeoutPromise from '../utils/offlineOrTimeoutPromise';
import { offlineSearchDrug } from '../offlineSearchService/offlineSearchDrug';
import { saveRecentSearches } from '../recentSearchService';

const saveRecentSearchAndReturnPayload = (searchParams, results, online) => {
  const url = `/app/drugLanding?search=${searchParams?.searchText}`;
  const item = { searchText: searchParams.searchText, url: url };
  const recentSearches = saveRecentSearches("drugSearch", item);
  return {
    searchParams: searchParams,
    drugResults: results.drugResults,
    isOffline: !online,
    recentSearches: recentSearches,
  };
};

export const drugSearchThunk = createAsyncThunk(
  'enhancedSearch/drugSearch',
  async (searchParams, { dispatch }) => {
    try {
      const apiPromise = searchApi.drugSearch(searchParams);
      const results = await Promise.race([
        apiPromise,
        offlineOrTimeoutPromise(),
      ]);
      dispatch(setApiReachable());
      return saveRecentSearchAndReturnPayload(searchParams, results, true);
    } catch (error) {
      dispatch(setApiUnreachable());
      try {
        const offlineCombinedSearch = await offlineSearchDrug(searchParams);
        return saveRecentSearchAndReturnPayload(searchParams, offlineCombinedSearch, false);
      } catch {
        return saveRecentSearchAndReturnPayload(searchParams, { drugResults: [], url: "" }, false);
      }
    }
  }
);